export enum CarouselBannerNameEnum {
  Deal100 = '100원딜',
  AppCoupon = 'APP회원 쿠폰',
  Membership = '핏펫플러스(멤버쉽프로그램)',
}
